import script from "./nowButtonCard.vue?vue&type=script&setup=true&lang=js"
export * from "./nowButtonCard.vue?vue&type=script&setup=true&lang=js"

import "./nowButtonCard.vue?vue&type=style&index=0&id=6a1f5c58&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a1f5c58"]])

export default __exports__